import { render } from "./ProductsGrid.vue?vue&type=template&id=a4baea0e"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"

import "./ProductsGrid.vue?vue&type=style&index=0&id=a4baea0e&lang=sass"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpinnerDots,QCardActions,QInfiniteScroll,QTable,QTr,QTd,QChip,QPageSticky,QBadge});
